{
  "title": "Meteor Swarm",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level evocation",
  "level": 9,
  "castingTime": "1 action",
  "range": "1 mile",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Blazing orbs of fire plummet to the ground at four different points you can see within range. Each creature in a 40-foot-radius sphere centered on each point you choose must make a Dexterity saving throw. The sphere spreads around corners. A creature takes 20d6 fire damage and 20d6 bludgeoning damage on a failed save, or half as much damage on a successful one. A creature in the area of more than one fiery burst is affected only once.",
    "The spell damages objects in the area and ignites flammable objects that aren’t being worn or carried."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
